import React from "react";
import { formatISO } from "date-fns";
import {
  getCurrentPuzzleSolution,
} from "../../lib/time-utils";

export const PuzzleDataContext = React.createContext();

function PuzzleDataProvider({ children }) {
  const { puzzleAnswers, puzzleGameDate, puzzleIndex } = React.useMemo(
    () => getCurrentPuzzleSolution(),
    []
  );
  const [gameData] = React.useState(puzzleAnswers);
  const puzzleDate = formatISO(puzzleGameDate, { representation: "date" });
  const puzzleStorageKey = `${puzzleDate}-${puzzleIndex}`;
  const categorySize = gameData[0].words.length;
  const numCategories = gameData.length;
  return (
    <PuzzleDataContext.Provider
      value={{
        gameData,
        numCategories,
        categorySize,
        puzzleDate,
        puzzleIndex,
        puzzleStorageKey,
      }}
    >
      {children}
    </PuzzleDataContext.Provider>
  );
}

export default PuzzleDataProvider;
